
export const isCustomFloorplan = (floorplans) => {
    return floorplans.length && floorplans.filter(({image_url_imperial}) => image_url_imperial).length === 0;
}
